import { QueryClient } from "@tanstack/react-query";

// Shared module-level instance so authProvider can seed/clear cached auth
// queries (e.g. ['auth', 'getPermissions']) synchronously on login/logout,
// instead of waiting on react-admin's own invalidate-then-refetch cycle.
export const queryClient = new QueryClient();
